export default function getPaginatedData(paginatedData) {
  // An array or a missing payload (empty response) both mean "no pages"
  if (Array.isArray(paginatedData) || !paginatedData)
    return {
      count: 0,
      pages: null,
      current: null,
      next: null,
      results: [],
    };
  return paginatedData;
}
